import React from 'react';

// list screen not pulled from Figma yet — header only
const Announcements: React.FC = () => <div className="page-header">
    <h1>Announcements</h1>
</div>;

export default Announcements;
